import { Controller } from "stimulus"

// Collapsible panel that remembers its open/closed state across page loads.
// Written for Stimulus 1.x (this app's version).
//
// Markup:
//   data-controller="collapse-persist"
//   data-collapse-persist-key="mapTools"                 // localStorage key (per preference)
//   <header ... data-action="click->collapse-persist#toggle keydown->collapse-persist#keydown">
//     ... <i data-target="collapse-persist.icon"></i>    // optional chevron
//   <body data-target="collapse-persist.body">           // the collapsible part
//
// If localStorage is unavailable (private mode, etc.) it degrades to a normal,
// non-persistent toggle.
export default class extends Controller {
  static targets = ["body", "icon"]

  connect() {
    this.collapsed = false
    const saved = this.readSaved()
    if (saved !== null) this.collapsed = saved // saved state wins over markup default
    this.render()
  }

  toggle() {
    this.collapsed = !this.collapsed
    this.save()
    this.render()
  }

  // Keyboard support for the role="button" header (Enter / Space).
  keydown(event) {
    if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
      event.preventDefault()
      this.toggle()
    }
  }

  render() {
    if (this.hasBodyTarget) this.bodyTarget.hidden = this.collapsed
    if (this.hasIconTarget) this.iconTarget.classList.toggle("is-collapsed", this.collapsed)
    const toggleEl = this.element.querySelector("[aria-expanded]")
    if (toggleEl) toggleEl.setAttribute("aria-expanded", String(!this.collapsed))
  }

  storageKey() {
    return `chronica:collapse:${this.data.get("key") || "panel"}`
  }

  readSaved() {
    try {
      const v = window.localStorage.getItem(this.storageKey())
      return v === null ? null : v === "1"
    } catch (e) {
      return null // storage blocked — fall back to markup default
    }
  }

  save() {
    try {
      window.localStorage.setItem(this.storageKey(), this.collapsed ? "1" : "0")
    } catch (e) {
      /* storage unavailable — non-fatal, toggle still works for this page */
    }
  }
}
